// extracted by mini-css-extract-plugin
module.exports = {"ProjectBreadcrumb":"ProjectBreadcrumb_IGf4o"};